import React, { Fragment } from 'react';
import { Route } from 'react-router-dom';
import { GoodsReceiveNoteReport } from './Pages';

export const GoodsReceiveNoteRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={GoodsReceiveNoteReport} />
    </Fragment>
)